import * as React from 'react';

const SVG = ({ width = '24px', height = '24px', className = '', viewBox = '0 0 24 24', color = 'red' }) => (
  <svg height={height} width={width} viewBox={viewBox} className={className}>
    <path
      fill={color}
      d='M13.995 1.827a1.745 1.745 0 00-2.969 0l-9.8 17.742a1.603 1.603 0 000 1.656 1.678 1.678 0 001.48.775H22.28a1.68 1.68 0 001.484-.775 1.608 1.608 0 00.003-1.656zM12 8h1v7h-1zm.5 10.5a1 1 0 111-1 1.002 1.002 0 01-1 1z'
    />
    <path fill='none' d='M0 0h24v24H0z' />
    <script />
  </svg>
);

export default SVG;
